/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Table_ActionsInputs */

const en_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const fr_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

const it_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni`)
};

const ru_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия`)
};

const es_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamiento`)
};

const zh_cn2_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_tags_manager_table_actions = /** @type {(inputs: Tags_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Tags_Manager_Table_ActionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_table_actions = /** @type {((inputs?: Tags_Manager_Table_ActionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Table_ActionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_table_actions(inputs)
	if (locale === "de") return de_tags_manager_table_actions(inputs)
	if (locale === "it") return it_tags_manager_table_actions(inputs)
	if (locale === "ru") return ru_tags_manager_table_actions(inputs)
	if (locale === "es") return es_tags_manager_table_actions(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_table_actions(inputs)
	if (locale === "ja") return ja_tags_manager_table_actions(inputs)
	if (locale === "hi") return hi_tags_manager_table_actions(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_table_actions(inputs)
	return en_tags_manager_table_actions(inputs)
});